import { Injectable } from '@angular/core';
import { Observable, map, shareReplay, switchMap } from 'rxjs';

import { TmtLoggerService } from 'tmt-logger';

import { ApolloClientService } from 'src/app/services/apollo-client.service';
import { blogNewsQueries } from 'src/app/graphql/queries/blog-news.queries';
import { BlogPost } from 'src/app/models/blog-post';

@Injectable()
export class BlogNewsService {
	constructor(
		private apolloClientService: ApolloClientService,
		private loggerService: TmtLoggerService,
	) {}

	public blogPosts$: Observable<BlogPost[]> = this.apolloClientService.abstractionLayerClient$.pipe(
		switchMap(client =>
			this.apolloClientService.observableWatchQuery$(client, {
				query: blogNewsQueries.blogNewsAll,
				errorPolicy: 'all',
			}),
		),
		map(response => {
			const posts = response.data?.blogNewsAll || [];
			return posts.map((item: any) => {
				const { __typename, ...blogPost } = item;
				return blogPost as BlogPost;
			});
		}),
		shareReplay(1),
	);
} 